import { Alert, Box, Button, Grid, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import BackspaceIcon from '@mui/icons-material/Backspace';
import React from 'react';
import { IZone } from '../../../models';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useCodeLoginFormManager } from './code-login-form.hook';

interface CodeLoginFormProps {
  zone: IZone;
  next: () => void;
}

export const CodeLoginForm = React.forwardRef((props: CodeLoginFormProps, ref) => {
  const { zone, next } = props;
  const codeRef = React.useRef('');
  const [{ formManager, isError }] = useCodeLoginFormManager({ zoneId: zone.id, next });

  const setCode = (code: string) => {
    codeRef.current = code;
    formManager.setFieldValue('code', code);
  };

  React.useImperativeHandle(ref, () => ({ onSubmit: () => formManager.submitForm() }), []);

  React.useEffect(() => {
    if (isError) {
      setCode('');
    }
  }, [isError]);

  React.useEffect(() => {
    const eventHandler = (event: KeyboardEvent) => {
      if (event.key === 'Backspace') {
        console.log('backspace button pressed');
        handleBackspace();
      }
    };
    document.addEventListener('keyup', eventHandler);
    return () => {
      document.removeEventListener('keyup', eventHandler);
    };
  }, []);

  const handleNumberClick = (number: string) => {
    const { code } = formManager.values;
    if (code.length < 4) {
      setCode(`${code}${number}`);
    }
  };

  const handleBackspace = () => {
    const _code = codeRef.current;
    console.log('handleBackspace', JSON.stringify(_code));
    setCode(_code.slice(0, _code.length - 1));
  };

  return (
    <Box>
      <Typography sx={{ textAlign: 'center' }}>Please enter your code</Typography>
      {isError && (
        <Alert color="error" icon={<CheckCircleIcon />}>
          Invalid code
        </Alert>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 4, px: 8 }}>
        {Array.from(Array(4).keys()).map((a) =>
          formManager.values.code.at(a) ? (
            <span key={a} style={{ fontSize: 20, fontWeight: 'bold' }}>
              {formManager.values.code.at(a)}
            </span>
          ) : (
            <CircleIcon key={a} fontSize="small" color="disabled" />
          ),
        )}
      </Box>
      <Grid container columns={3} sx={{ justifyContent: 'right', my: 4 }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((n) => (
          <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }} key={n}>
            <Button onClick={() => handleNumberClick(n.toString())} sx={{ color: 'black', fontSize: 20 }}>
              {n}
            </Button>
          </Grid>
        ))}
        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleBackspace} sx={{ color: 'black' }}>
            <BackspaceIcon />
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
});
